// Routerの拡張子なしimportをPermission別一覧ラッパーへ接続する。
export { default } from './ProjectListAccessPage'
